import {Component, Input, OnInit} from '@angular/core';
import {DictionaryObject} from '../../../../../../../../../../../common/api';
import {FileUtils} from '../../../../../../../../../../../common/utils';
import {CorporateProfileMember, DirectorsDocuments} from '../../../../../../api/entity';
import {FileDownloadService} from '../../../../../../api/service';


@Component({
    selector: 'tfl-document-directors',
    template: require('./document.directors.template.html')
})
export class DocumentDirectorsComponent implements OnInit {

    @Input() directors: DirectorsDocuments;
    @Input() attachmentSubTypes: DictionaryObject[];
    @Input() profileId: number;

    allDirectors: CorporateProfileMember[];

    constructor(private _fileDownloadService: FileDownloadService) {
    }

    ngOnInit(): void {
        this.allDirectors = [
            ...this.directors.corporate,
            ...this.directors.individual
        ];
    }

    onDownloadFile(fileId, director: CorporateProfileMember) {
        this._fileDownloadService.downloadFile(fileId)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-details/documents/corporate/document/directors/document.directors.component.ts